// extracted by mini-css-extract-plugin
module.exports = {"hoverlessContainer":"style-module_hoverlessContainer__IkQ2M4HVVVcZ1cxa7R3N7","content":"style-module_content__3shy0CZESwYEs7Q3kj2-B2"};